/**
 * ProShip Design System — Typography (Foundation Layer)
 */
export const FONT = 'Poppins, sans-serif'

export const SIZE = {
  // Sub-12px steps, added for the Prozo Direct module: TRD 4.2 specifies a 10px mode
  // chip and 11px table meta, and the scale previously bottomed out at 12px. Additive
  // only — no existing key changed. Use sparingly: these are for chips, badges and
  // dense table meta, never for body copy.
  '4xs': '0.625rem', // 10px
  '3xs': '0.6875rem', // 11px
  '2xs': '0.75rem',
  xs: '0.82rem',
  sm: '0.90rem',
  base: '0.95rem',
  md: '1.02rem',
  lg: '1.12rem',
  xl: '1.25rem',
  '2xl': '1.45rem',
  '3xl': '1.75rem',
  '4xl': '2.25rem',
}

export const WEIGHT = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extra: 800,
}

export const textSx = (size = 'base', weight = 'regular', color) => ({
  fontFamily: FONT,
  fontSize: SIZE[size] || size,
  fontWeight: WEIGHT[weight] || weight,
  ...(color ? {color} : {}),
})
